<template>
  <div class="container-condition">
    <div class="item variable">
      <Label :text="$t('apps.payroll.label.variable')" />
      <BaseDropdown
        v-model="form.variable"
        :options="variableOptions"
        :disabled="disabled"
      />
    </div>
    <div class="item operator">
      <Label :text="$t('apps.payroll.label.operator')" />
      <BaseDropdown
        v-model="form.operator"
        :options="operatorOptions"
        :disabled="disabled"
      />
    </div>
    <div class="item value">
      <Label :text="$t('apps.payroll.label.value')" />
      <BaseInputNumber
        v-model="form.value"
        :disabled="disabled"
        :classNames="[{ 'is-invalid': isValid.value === false }]"
        @change="handleValueChange"
      />
    </div>
    <div class="item if-ture">
      <Label :text="$t('apps.payroll.label.iftrue')" />
      <BaseInputVariable
        v-model="form.iftrue"
        :text="form.iftrue"
        :valid.sync="isValid.iftrue"
        :validateForm.sync="validateFormIFTrue"
        :clearForm.sync="clearFormIfTrue"
        :variables="variables"
        :disabled="disabled"
        :helper="$t('apps.payroll.message.typeattoselectvariable')"
      />
    </div>
    <div class="item if-false">
      <Label :text="$t('apps.payroll.label.iffalse')" />
      <BaseInputVariable
        v-model="form.iffalse"
        :text="form.iffalse"
        :valid.sync="isValid.iffalse"
        :validateForm.sync="validateFormIfFalse"
        :clearForm.sync="clearFormIfFalse"
        :variables="variables"
        :disabled="disabled"
        :helper="$t('apps.payroll.message.typeattoselectvariable')"
      />
    </div>
  </div>
</template>

<script>
import {
  PAYROLL_CONDITION_VARIABLE,
  PAYROLL_CONDITION_OPERATOR,
} from '@/helpers/enum'
import { cloneDeep } from 'lodash'

export default {
  props: ['value', 'disabled'],

  data () {
    return {
      form: {
        variable: PAYROLL_CONDITION_VARIABLE.WAGES,
        operator: PAYROLL_CONDITION_OPERATOR.GREATER_THAN,
        value: null,
        iftrue: null,
        iffalse: null,
      },
      variables: [
        {
          code: PAYROLL_CONDITION_VARIABLE.WAGES,
          name: this.$t('apps.payroll.message.variablewages'),
        },
      ],
      isValid: {
        value: null,
        iftrue: null,
        iffalse: null,
      },
      validateFormIFTrue: null,
      validateFormIfFalse: null,
      clearFormIfTrue: null,
      clearFormIfFalse: null,
    }
  },

  computed: {
    variableOptions () {
      return [
        {
          text: this.$t('apps.payroll.message.variablewages'),
          value: PAYROLL_CONDITION_VARIABLE.WAGES,
        },
      ]
    },
    operatorOptions () {
      return [
        {
          text: this.$t('apps.payroll.message.gt'),
          value: PAYROLL_CONDITION_OPERATOR.GREATER_THAN,
        },
        {
          text: this.$t('apps.payroll.message.lt'),
          value: PAYROLL_CONDITION_OPERATOR.LESS_THAN,
        },
        {
          text: this.$t('apps.payroll.message.eq'),
          value: PAYROLL_CONDITION_OPERATOR.EQUAL,
        },
      ]
    },
  },

  watch: {
    'isValid': {
      handler (newVal) {
        const valid = !!(
          (newVal.iftrue === true && newVal.iffalse === true) &&
          (this.value && this.iftrue && this.iffalse)
        )
        this.$emit('update:valid', valid)
      },
      deep: true,
    },
    'value.variable': {
      handler (newVal) {
        this.form.variable = this.value.variable
      },
      deep: true,
    },
    'value.operator': {
      handler (newVal) {
        this.form.operator = this.value.operator
      },
      deep: true,
    },
    'value.value': {
      handler (newVal) {
        this.form.value = this.value.value
      },
      deep: true,
    },
    'value.iftrue': {
      handler (newVal) {
        this.form.iftrue = this.value.iftrue
      },
      deep: true,
    },
    'value.iffalse': {
      handler (newVal) {
        this.form.iffalse = this.value.iffalse
      },
      deep: true,
    },
    'form': {
      handler (newVal) {
        const valid = !!(
          (this.isValid.iftrue === true && this.isValid.iffalse === true) &&
          (newVal.value && newVal.iftrue && newVal.iffalse)
        )
        this.$emit('update:valid', valid)
        this.$emit('input', this.form)
      },
      deep: true,
    },
  },

  created () {
    this.form = cloneDeep(this.value)
  },

  mounted () {
    this.$emit('update:validateFormValue', this.validateFormValue)
    this.$emit('update:validateFormIFTrue', this.validateFormIFTrue)
    this.$emit('update:validateFormIfFalse', this.validateFormIfFalse)
    this.$emit('update:clearFormIfTrue', this.clearFormIfTrue)
    this.$emit('update:clearFormIfFalse', this.clearFormIfFalse)

    setTimeout(() => {
      const valid = !!(
        (this.isValid.iftrue === true && this.isValid.iffalse === true) &&
        (this.isValid.value && this.isValid.iftrue && this.isValid.iffalse)
      )
      this.$emit('update:valid', valid)
    }, 100)
  },

  methods: {
    validateFormValue () {
      if (this.form.value === null || this.form.value === '') {
        this.isValid.value = false
      } else {
        this.isValid.value = true
      }
    },
    handleValueChange () {
      this.validateFormValue()
    },
  },
}
</script>

<style scoped>
.container-condition {
  display: flex;
}

.item {
  flex: 1;
  margin-right: 12px;
}

.variable {
  max-width: 120px;
}

.operator, .value {
  max-width: 120px;
}

.if-ture, .if-false {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BasePayrollCondition.vue